var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconEditPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83958 2.89982L3.36624 8.69315C3.15958 8.91315 2.95958 9.34649 2.91958 9.64649L2.67291 11.8065C2.58624 12.5865 3.14624 13.1198 3.91958 12.9865L6.06624 12.6198C6.36624 12.5665 6.78624 12.3465 6.99291 12.1198L12.4662 6.32649C13.4129 5.32649 13.8396 4.18649 12.3662 2.79315C10.8996 1.41315 9.78624 1.89982 8.83958 2.89982Z",
    stroke: "#253D87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92578 3.8667C8.21245 5.7067 9.70578 7.11337 11.5591 7.30003",
    stroke: "#253D87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.1665H14",
    stroke: "#253D87",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconEditPrimary);
export default __webpack_public_path__ + "static/media/common_icon_edit_primary.dbb93dc200be74186a188a5ede4f0ab2.svg";
export { ForwardRef as ReactComponent };